import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="feedback-form"
export default class extends Controller {
  static targets = ["feedbackForm", "hiddenFormField"]
  connect() {
    console.log(this.submitButtonTarget);
  }

  submitForm(e) {
    e.preventDefault();

    const submitValue = e.currentTarget.value
    this.hiddenFormFieldTarget.value = submitValue;
    this.feedbackFormTarget.requestSubmit();
  }
}
